<template>
  <div class="ma-4 app">
    <div class="text-h4 mb-4">Relatórios de Pesquisa de Satisfação</div>
    <v-tabs v-model="tabs" background-color="background">
      <v-tab v-for="n in tipos" :key="n">
        {{ tipo[n - 1] }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <RelatorioResumidoPesquisaSatisfacao />
      </v-tab-item>
      <v-tab-item>
        <RelatorioDetalhadoPesquisaSatisfacao />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import RelatorioResumidoPesquisaSatisfacao from '../components/relatorioResumidoPesquisaSatisfacao/_views/RelatorioResumidoPesquisaSatisfacao'
import RelatorioDetalhadoPesquisaSatisfacao from '../components/relatorioDetalhadoPesquisaSatisfacao/_views/RelatorioDetalhadoPesquisaSatisfacao'

export default {
  components: { RelatorioResumidoPesquisaSatisfacao, RelatorioDetalhadoPesquisaSatisfacao },
  data: () => ({
    tipos: 2,
    tab: null,
    tabs: 2,
    tipo: ['RESUMIDO', 'DETALHADO'],
  }),
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
